import { USERMODES } from 'Types'
import {
  SET_AUTH_TOKEN
  SET_USER_ACLS
  SET_USER_MODE
  SET_USER_ROLES
  SET_IS_MONTEUR
} from 'Actions/actionTypes'

initialState = {
  authToken: undefined
  isMonteur: true
  userAcls: []
  userMode: USERMODES.SIMPLE
  userRoles: []
}

export default (state = initialState, { payload, type }) ->
  switch(type)
    when SET_AUTH_TOKEN
      { state..., authToken: payload.authToken }
    when SET_USER_ACLS
      { state..., userAcls: payload.data }
    when SET_USER_MODE
      { state..., userMode: payload.data }
    when SET_USER_ROLES
      { state..., userRoles: payload.data }
    when SET_IS_MONTEUR
      { state..., isMonteur: payload.data }
    else
      state
